// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1RcCm";
var _4 = "header-fdu4g";
var _5 = "header__item-27jYv";
var _6 = "details-2S_43";
var _7 = "details__block-tOAsa";
var _8 = "details__item-3F09M";
var _9 = "text__item-36bWJ";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "header", _5 as "header__item", _6 as "details", _7 as "details__block", _8 as "details__item", _9 as "text__item" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "header": _4, "header__item": _5, "details": _6, "details__block": _7, "details__item": _8, "text__item": _9 }
